"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestBody = getRequestBody;
exports.getHeaders = exports.handleData = exports.forceFetch = exports.isQuery = exports.isMutation = void 0;

var isMutation = function isMutation(request) {
  return request.operationKind === 'mutation';
};

exports.isMutation = isMutation;

var isQuery = function isQuery(request) {
  return request.operationKind === 'query';
};

exports.isQuery = isQuery;

var forceFetch = function forceFetch(cacheConfig) {
  return !!(cacheConfig && cacheConfig.force);
};

exports.forceFetch = forceFetch;

var handleData = function handleData(response) {
  var contentType = response.headers.get('content-type');

  if (contentType != null && contentType.indexOf('application/json') !== -1) {
    return response.json();
  }

  return response.text();
};

exports.handleData = handleData;

function getRequestBodyWithUploadables(request, variables, uploadables) {
  var formData = new FormData();

  if (process.env.NODE_ENV !== "production" && request.text != null) {
    formData.append('query', request.text);
  } else if (request.id != null) {
    formData.append('documentId', request.id);
  } else {
    formData.append('query', request.text);
  }

  formData.append('variables', JSON.stringify(variables));
  Object.keys(uploadables).forEach(function (key) {
    /* $FlowFixMe[method-unbinding] This comment suppresses an error when
     * upgrading Flow to version 0.153.0. To see the error delete this comment
     * and run Flow. */
    if (Object.prototype.hasOwnProperty.call(uploadables, key)) {
      formData.append(key, uploadables[key]);
    }
  });
  return formData;
}

function getRequestBodyWithoutUplodables(request, variables) {
  var body = {};

  if (process.env.NODE_ENV !== "production" && request.text != null) {
    body = {
      query: request.text,
      variables: variables
    };
  } else if (request.id != null) {
    body = {
      documentId: request.id,
      variables: variables
    };
  } else {
    body = {
      query: request.text,
      variables: variables
    };
  }

  return JSON.stringify(body);
}

function getRequestBody(request, variables, uploadables) {
  if (uploadables) {
    return getRequestBodyWithUploadables(request, variables, uploadables);
  }

  return getRequestBodyWithoutUplodables(request, variables);
}

var getHeaders = function getHeaders(uploadables) {
  if (uploadables) {
    return {
      Accept: '*/*'
    };
  }

  return {
    'Accept': 'application/json',
    'Content-type': 'application/json'
  };
};

exports.getHeaders = getHeaders;